var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout md-size-60 md-alignment-center-center"},[_c('div',{staticClass:"md-layout-item md-size-75 md-medium-size-80 md-small-size-100"},[_c('CategoryFaves',{attrs:{"categoryName":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }